import React, { SVGProps } from 'react';

const SvgArrowUturnLeft = (props) => (
	<svg
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		className='svg-icon'
		{...props}>
		<path
			d='M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3'
			stroke='currentColor'
			strokeWidth={1.5}
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
export default SvgArrowUturnLeft;
